/*
 * Copyright (c) 2018-Present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

import { useOktaAuth } from "@okta/okta-react";
import React, { useState, useEffect, useContext, useRef } from "react";
// import { Button, Header } from "semantic-ui-react";
import Button from 'react-bootstrap/Button'
import Dashboard from "./pages/Dashboard";
import { useNavigate } from "react-router-dom"
import UserPrefContext from '../src/context/userPrefContext'
import DictionaryContext from "./context/dictionaryContext"
import AuthContext from "./context/authContext";
import LoginBoxDB from "./LoginBoxDB";
import jwt_decode from 'jwt-decode'
import CompanyContext from "./context/companyContext";


const Home = (props) => {
    const userPrefCtx = useContext(UserPrefContext)
    const dictContext = useContext(DictionaryContext)
    const authCtx = useContext(AuthContext)
    const companyCtx = useContext(CompanyContext)
    const componentMounted = useRef(true)
    const [showDBLogin, setShowDBLogin] = useState(false)

    const { authState, oktaAuth } = useOktaAuth();
    const [userInfo, setUserInfo] = useState(null);
    const navigate = useNavigate()
//   const dashboardFlag = false;
//   const visitFlag = false;

// console.log("Home - authCtx", authCtx, "props.authMode", props.authMode)

    // const restoreSession = () => {
    //     try {
    //         let data = localStorage.getItem("db-auth-access-return")

    //         if (!!data) {
    //             data = JSON.parse(data)
    //             console.log("restoreSession - data restored", data)
    //             if (!!data.accessToken && !isTokenExpired(data.accessToken)) {
    //                 authCtx.setAuthMode(props.authMode)
    //                 authCtx.setToken(data.accessToken)
    //                 authCtx.setIsAuthenticated(true)
        
    //                 authCtx.setUserInfo({
    //                     first_name: data.first_name,
    //                     last_name: data.last_name,
    //                     is_him_user: data.is_him_user,
    //                     is_ipad_user: data.is_ipad_user,
    //                     is_readonly: data.is_readonly,
    //                     is_site_admin: data.is_site_admin,
    //                     is_superuser: data.is_superuser,
    //                     is_writeuser: data.is_writeuser,
    //                     name: data.first_name + ' ' + data.last_name,
    //                 })
    //             }
                
    //         }
            
    //     }
    //     catch (e) {
    //         console.log(e)
    //     }

    // } 

    const dbAuthRestore = (authMode) => {
        try {
            let data = localStorage.getItem("db-auth-access-return")
            // console.log("restoring Session - local storage", data, "!!data", !!data)
            if (!!data) {
                data = JSON.parse(data)
                // console.log("restoring Session - parsed data", data, "!!data.access_token", !!data.access_token, "data.access_token", data.access_token)
                
                if (!!data.access_token && !isTokenExpired(data.access_token)) {
                    
                    // console.log("restoring Session - data", data)
                    // userPreferenceCtx.setBearerTokenFunction(data.access_token)
                    authCtx.setToken(data.access_token)
                    authCtx.setIsAuthenticated(true)
                    
                    authCtx.setAuthMode(authMode)

                    const uInfo = {
                        first_name: data.first_name,
                        last_name: data.last_name,
                        is_him_user: data.is_him_user,
                        is_ipad_user: data.is_ipad_user,
                        is_readonly: data.is_readonly,
                        is_site_admin: data.is_site_admin,
                        is_superuser: data.is_superuser,
                        is_writeuser: data.is_writeuser,
                        name: data.first_name + ' ' + data.last_name,
                        // email: 'unknown',
                        // email_verified: false,
                        family_name: data.last_name,
                        given_name: data.first_name,
                        // locale: '',
                        // preferred_username: '',
                        // zoneinfo: '',
                        username: data.username,
                    }
        
                    authCtx.setUserInfo(uInfo)
                    // setUserInfo(uInfo)
                    // setIsAuthenticated(true)
                    // setToken(data.accessToken)
                }
            }
            
        }
        catch (e) {
            console.log(e)
        }
        
    }

    // if (!!!authCtx.authMode) {
    //     authCtx.setAuthMode(props.authMode)
    // }

    const isTokenExpired = token => {
        if (!!!token) {
            console.log("isTokenExpired - yes (no token)", token)
            return true
        }

        let decoded = jwt_decode(token)
        if (!!!decoded.exp) {
            console.log("isTokenExpired - yes (decoded.exp is null)", decoded.exp)
            return true
        }

        // console.log("isTokenExpired - new Date(decoded.exp*1000) < new Date()", new Date(decoded.exp*1000) < new Date())
        return new Date(decoded.exp*1000) < new Date()
    }

    useEffect(() => {
        // console.log("Home - mounting - useEffect 1")
        componentMounted.current = true
        if (!!companyCtx.company.auth_mode && !!!authCtx.authMode) {
            if (companyCtx.company.auth_mode === 'OKTA') {
                authCtx.setAuthMode(companyCtx.company.auth_mode)
            } else {
                // check if session should be restored after page reload 
                // console.log("Home - restore session: companyCtx.company", companyCtx.company)
                dbAuthRestore(companyCtx.company.auth_mode)
            }
        }

        return () => {
            // console.log("Unmounting Home #1")
            componentMounted.current = false
        }
        
    }, [companyCtx.company.auth_mode, authCtx.authMode])

    // useEffect(() => {
    //     if (!!props.authMode && props.authMode === 'DB' && !!!authCtx.authMode) {
    //         // check if session should be restored after page reload 
    //         dbAuthRestore(props.authMode)
    //     } else if (!!props.authMode && props.authMode === 'OKTA' && !!!authCtx.authMode) {
    //         authCtx.setAuthMode(props.authMode)
    //     }
    // }, [props.authMode])



    useEffect(() => {
        // console.log("Home: mounting component 2; authState", authState, "authCtx", authCtx, "props", props)
        componentMounted.current = true
        if (companyCtx.company.auth_mode === 'OKTA' || authCtx.authMode === 'OKTA') {
            if (!!!authCtx.authMode) {
                authCtx.setAuthMode(companyCtx.company.auth_mode)
            }
            if (!authState || !authState.isAuthenticated) {
                // When user isn't authenticated, forget any user info
                setUserInfo(null);
            } else {
                oktaAuth
                    .getUser()
                    .then((info) => {
                        // console.log("Home - componentMounted.current", componentMounted.current)
                        if (componentMounted.current) { 
                            // console.log("Home - User Info", info)
                            setUserInfo(info);

                            userPrefCtx.setUserGroups(authState.accessToken.claims.groups)
                            userPrefCtx.setBearerTokenFunction(oktaAuth.getAccessToken())
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                    });

                // set partial user preference context


                if (authState.accessToken.claims.groups.indexOf(process.env.REACT_APP_MAIN_APP_GROUP) < 0 &&
                    authState.accessToken.claims.groups.indexOf(process.env.REACT_APP_HIM_GROUP) >= 0) {
                        // console.log('Home - navigating to /him')
                        // console.log("Home2 - AuthState", authState)
                        props.onModeChange('him')
                        navigate('/him')
                }


                if (authState.accessToken.claims.groups.indexOf(process.env.REACT_APP_MAIN_APP_GROUP) < 0 &&
                    authState.accessToken.claims.groups.indexOf(process.env.REACT_APP_IPAD_GROUP) >= 0) {
                    // console.log('Home - navigating to /ipad')
                    // console.log("Home3 - AuthState", authState)
                    props.onModeChange('ipad')
                    navigate('/ipad')
                }
            } 
        } else  {
            // console.log("Home - authCtx", authCtx)

            if (!!!authCtx.token) {
                // try to restore session
                // restoreSession()

                // console.log("Session restored? - authCtx.userInfo", authCtx.userInfo)
            }
            // if (authCtx.isAuthenticated) {
            if (componentMounted.current) {
                setUserInfo(authCtx.userInfo)
            }

            // } else {
            //     setUserInfo(null)

            // }
        }
    
        return () => {
            // console.log("Unmounting Home #2")
            componentMounted.current = false
        }
    }, [authCtx.authMode, authCtx.userInfo, authState, oktaAuth]); // Update if authState changes

  const login = async () => {
    if (companyCtx.company.auth_mode === 'OKTA') {
        oktaAuth.signInWithRedirect({ originalUri: "/" });
    } else  {
        setShowDBLogin(true)
    }
    
  };

    const hideDbLogin = () => {
        setShowDBLogin(false)
    }

    const handleCancel = () => {
        setShowDBLogin(false)
    }



  if (!authState) {
    return <div>Loading...</div>;
  }

// console.log("Home - auhCtx - before render", authCtx)

    return (
        <div id="home">
            <div>
                {companyCtx.company.auth_mode === 'OKTA' && authState.isAuthenticated && !userInfo && (
                    <div>Loading user information...</div>
                )}

                {((companyCtx.company.auth_mode === 'OKTA' && authState.isAuthenticated && userInfo && authState.accessToken.claims.groups.indexOf(process.env.REACT_APP_MAIN_APP_GROUP) >= 0)
                    || 
                    ( authCtx.isAuthenticated )) && (
                    <div>
                    <p id="welcome">
                        Welcome, &nbsp;
                        {userInfo?.name}!
                    </p>

                    <div>
                        <Dashboard />
                    </div>
                    </div>
                )}

                {((companyCtx.company.auth_mode === 'OKTA' && !authState.isAuthenticated) || (companyCtx.company.auth_mode !== 'OKTA'  && !authCtx.isAuthenticated  && !showDBLogin)) && (
                    <div>
                        <div style={{ left: "50%", top: "20%", position: "fixed" }}>
                            <div className="home_login_button">
                                <Button id="login-button" variant='primary' onClick={login}>
                                    Login
                                </Button>
                            </div>
                        </div>
                    </div>
                )}

                {companyCtx.company.auth_mode !== 'OKTA' && !!!authCtx.isAuthenticated && 
                    <LoginBoxDB show={showDBLogin} onHide={hideDbLogin} onCancel={handleCancel} mode='login' />
                }
            </div>
        </div>
    )
}

export default Home;
